<div class="step-container">
  <div class="step-header">
    <div class="step-header-icon"><i class="fas fa-shield-alt" aria-hidden="true"></i></div>
    <h2>Código de seguridad</h2>
    <p>Recibirá un código en el correo registrado.</p>
  </div>
  <div class="contact-box">
    <div class="contact-item"><i class="far fa-envelope" aria-hidden="true"></i> <span>{{ correoOfuscado }}</span></div>
  </div>
  <div class="button-container">
    <button type="button" class="btn btn-secondary" (click)="back.emit()">Atrás</button>
    <button type="button" class="btn btn-primary" (click)="enviarOTP()">Enviar código</button>
  </div>
</div>
